// Sumber feed untuk dinding Monitor CCTV (permintaan Andra 28 Okt 2026).
//
// Daftar live diambil dari riset terverifikasi 25 Okt 2026
// (~/kerja/riset/cctv-live-1025/DAFTAR.md): 29 relay HLS publik, H.264, tanpa login.
// Diurutkan dari resolusi tertinggi supaya 9 sel pertama memakai feed 720p.
//
// Aturan yang dijaga:
// - Maksimal MAX_LIVE siaran live serentak (decode klien: 9 tile 720p sudah berat).
// - Sel di luar layar dijeda (lihat CctvWall).
// - Tidak ada perekaman, tidak ada rehost.
// - Sumber dicantumkan per sel (syarat riset STELLA 25 Okt).
// - Tidak ada penarikan stream YouTube: YouTube hanya embed resmi, dan embed tidak
//   dipakai di dinding ini.

export const MAX_LIVE = 9;

// 29 relay terverifikasi, terurut resolusi tertinggi dulu.
export const LIVE_FEEDS = [
  { nama: 'GT CAKUNG', lokasi: 'Jakarta Timur', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/81/index.m3u8' },
  { nama: 'JORR KM 23+150', lokasi: 'Jakarta Selatan', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/27/index.m3u8' },
  { nama: 'JORR KM 27+100', lokasi: 'Jakarta Selatan', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/19/index.m3u8' },
  { nama: 'JORR KM 24+150', lokasi: 'Jakarta Selatan', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/25/index.m3u8' },
  { nama: 'JORR KM 22+670', lokasi: 'Jakarta Selatan', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/78/index.m3u8' },
  { nama: 'JORR KM 25+540', lokasi: 'Jakarta Selatan', host: 'JTD',
    url: 'https://camera.jtd.co.id/camera/share/tios/2/80/index.m3u8' },
  { nama: 'KM 58+400 B', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/501264524429471982550467.m3u8' },
  { nama: 'GT KOJA', lokasi: 'Jakarta Utara', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/539029826611825636156852.m3u8' },
  { nama: 'GT AMPERA 1', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/314944433014333275671534.m3u8' },
  // Cadangan live bila kuota MAX_LIVE dinaikkan kelak.
  { nama: 'JORR KM 21+300', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/743206696886685995011480.m3u8' },
  { nama: 'JORR KM 22+400', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/269363542266933731794240.m3u8' },
  { nama: 'JORR KM 23+000', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/121810470572829194057319.m3u8' },
  { nama: 'JORR KM 23+200', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/271820726275436138198288.m3u8' },
  { nama: 'JORR KM 23+600', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/101502919369166746058073.m3u8' },
  { nama: 'JORR KM 24+000', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/222888349210580537521273.m3u8' },
  { nama: 'KM 58+400 A', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/687489889091511277827377.m3u8' },
  { nama: 'GT AMPERA 2', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/645733666909706688403926.m3u8' },
  { nama: 'GT FATMAWATI 2', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/837865507132921558450011.m3u8' },
  { nama: 'GT GEDONG 2', lokasi: 'Jakarta Timur', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/420058855294412322884038.m3u8' },
  { nama: 'GT KP RAMBUTAN', lokasi: 'Jakarta Timur', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/501026346597024351642009.m3u8' },
  { nama: 'GT LENTENG 1', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/439272921460954347649828.m3u8' },
  { nama: 'JORR KM 19+850', lokasi: 'Jakarta Selatan', host: 'HK-OPT',
    url: 'https://pub.hk-opt.com/LiveApp/streams/675323017321643087627650.m3u8' },
  { nama: 'KM 59+000 A', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/095660838019901274554950.m3u8' },
  { nama: 'KM 59+400 A', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/675323017321643087627650.m3u8' },
  { nama: 'KM 60+000 A', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/062223762734246730973930.m3u8' },
  { nama: 'KM 60+000 B', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/381024135984437558197100.m3u8' },
  { nama: 'KM 61+400 A', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/756751654695732090756915.m3u8' },
  { nama: 'KM 61+400 B', lokasi: 'Jakarta', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/241370079371388169899174.m3u8' },
  { nama: 'GT KB BAWANG', lokasi: 'Jakarta Utara', host: 'HK-OPT2',
    url: 'https://extstream.hk-opt2.com/LiveApp/streams/710404214066673275657182.m3u8' },
];

// Rekaman berulang untuk sel yang bukan siaran langsung.
// - cctv-arsip-1/2: rekaman lama yang sudah ada di dinding sejak revisi pertama,
//   dipotong dari footage arsip proyek. Tetap dipertahankan (permintaan Andra).
// - cctv-andra-1/2/3: tiga klip 1080p Andra (28 Okt), dipotong HANYA pada segmen
//   kamera diam, loop mulus dengan crossfade pendek, diekspor H.264 720p.
// Berkas ikut repo (public/demo), tidak diambil saat runtime.
export const BACKUP_CLIPS = [
  '/demo/cctv-arsip-1.mp4',
  '/demo/cctv-arsip-2.mp4',
  '/demo/cctv-andra-1.mp4',
  '/demo/cctv-andra-2.mp4',
  '/demo/cctv-andra-3.mp4',
];

// Label lokasi untuk sel rekaman. Sengaja bukan "OFFLINE": sel ini tampil
// seperti kamera aktif (permintaan Andra 28 Okt). Status asli hanya di data internal.
export const BACKUP_PLACES = [
  { nama: 'ATRIUM MALL', lokasi: 'Jakarta Pusat' },
  { nama: 'LOBI GEDUNG A', lokasi: 'Jakarta Selatan' },
  { nama: 'LIFT SERVIS 2', lokasi: 'Jakarta Pusat' },
  { nama: 'LORONG TIMUR', lokasi: 'Jakarta Barat' },
  { nama: 'HALTE BUSWAY', lokasi: 'Jakarta Pusat' },
  { nama: 'AREA PARKIR B1', lokasi: 'Jakarta Selatan' },
  { nama: 'PINTU MASUK 3', lokasi: 'Jakarta Utara' },
];

// Susun daftar sel untuk tata letak count x count.
// Sel pertama memakai siaran live (maks MAX_LIVE), sisanya rekaman berulang.
export function buildTiles(count) {
  const tiles = [];
  for (let i = 0; i < count; i++) {
    const id = `CAM-${String(i + 1).padStart(2, '0')}`;
    if (i < MAX_LIVE && i < LIVE_FEEDS.length) {
      const f = LIVE_FEEDS[i];
      // `clip` dipakai bila siaran live gagal, supaya sel tidak pernah hitam.
      tiles.push({
        id, nama: f.nama, lokasi: f.lokasi, host: f.host, url: f.url, live: true,
        clip: BACKUP_CLIPS[i % BACKUP_CLIPS.length],
      });
    } else {
      const n = i - MAX_LIVE;
      const place = BACKUP_PLACES[n % BACKUP_PLACES.length];
      tiles.push({
        id, nama: place.nama, lokasi: place.lokasi, host: 'NVR', url: null,
        clip: BACKUP_CLIPS[n % BACKUP_CLIPS.length], live: false,
      });
    }
  }
  return tiles;
}
